import {Injectable} from '@angular/core';
import {environment} from "../../../../../environments/environment";
import {ResultAnalyzerClientService} from "./result-analyzer-client.service";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {ResultAnalysis} from "../models/result-analysis";
import {FusionAuthService} from "../../../../shared/services/fusion-auth";

@Injectable({
  providedIn: 'root'
})
export class ResultAnalyzerService {

  constructor(private clientService: ResultAnalyzerClientService, private userService: FusionAuthService){
  }

  get IsFeatureEnabled(): boolean {
    if (!environment.aiAnalysis.enabled) return false;
    if (environment.aiAnalysis.enabledRoles.includes("*")) return true;

    const userRole = this.userService.Profile.role;

    return environment.aiAnalysis.enabledRoles.includes(userRole);
  }

  checkClient(clientCode: string): Observable<boolean> {
    return this.clientService.checkIfClientIsEnabled(clientCode)
      .pipe(map(x => x.body ?? false));
  }

  checkIfOrderHasBeenAnalyzed(orderCode: string): Observable<boolean> {
    return this.clientService.checkIfOrderHasBeenAnalyzed(orderCode)
      .pipe(map(x => x.body ?? false));
  }

  getOrderAnalyzes(orderCode: string): Observable<ResultAnalysis[]> {
    return this.clientService.getAnalysis(orderCode)
      .pipe(
        map(x => x.body ?? []),
        map(x => {
          x.forEach(y => {
            y.analysis = y.analysis.replace(/\r\n|\r|\n/g, '<br>');
          });
          x.sort((a, b) => a.sort - b.sort);
          return x;
        })
      );
  }
}
